import React, { useState } from "react";
import StrandsTable from "./StrandsTable";
import GradeLevelsTable from "./GradeLevelsTable";
import SubjectsTable from "./SubjectsTable";

export default function AdminPanel({ user, setUser }) {
  // State for management tabs
  const [activeTab, setActiveTab] = useState("strands");

  return (
    <div style={{ padding: "32px", minHeight: "100vh", background: "#f8f9fa" }}>
      <h1 style={{ fontWeight: 800, color: "#7B3F00", marginBottom: 24 }}>Admin Panel</h1>
      <div style={{ display: "flex", gap: 16, marginBottom: 32 }}>
        <button
          className={`btn ${activeTab === "strands" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("strands")}
        >
          Manage Strands
        </button>
        <button
          className={`btn ${activeTab === "gradeLevels" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("gradeLevels")}
        >
          Manage Grade Levels
        </button>
        <button
          className={`btn ${activeTab === "subjects" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("subjects")}
        >
          Manage Subjects
        </button>
      </div>
      <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 16px #7B3F0022", padding: 24 }}>
        {activeTab === "strands" && (
          <div>
            <h2>Strands Management</h2>
            {/* CRUD table and form for strands will go here */}
            <StrandsTable />
          </div>
        )}
        {activeTab === "gradeLevels" && (
          <div>
            <h2>Grade Levels Management</h2>
            <GradeLevelsTable />
          </div>
        )}
        {activeTab === "subjects" && (
          <div>
            <h2>Subjects Management</h2>
            <SubjectsTable />
          </div>
        )}
      </div>
    </div>
  );
}